import { actionCreator } from '@ardoq/rxbeach';

export const reportNavigationReset = actionCreator('[report] NAVIGATION_RESET');
